module.exports = __webpack_public_path__ + "static/media/gcp.8aea7048.svg";